import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource);

export class FormService {

    static URL = process.env.API_URL + process.env.API_VER;
    static RESOURCE = '/forms/';
    static COMMENT_RESOURCE = '/comments/';
    static TYPE_RESOURCE = '/form-types/';
    static CRITERIA_RESOURCE = '/criteria/';
    static RESPONSE_RESOURCE = '/responses/';

    static all(queryParams = {}) {
        return Vue.http.get(this.URL + this.RESOURCE, { params: queryParams })
            .then(response => {
                return response.data;
            }, error => {
                return error;
            }
            );
    }

    static store(data = {}) {
        return Vue.http.post(this.URL + this.RESOURCE, data)
            // .then(response => {
            //     return response.data;
            // }, error => {
            //     return error;
            // }
            // );
    }

    static show(id, queryParams) {
        queryParams = (typeof queryParams !== 'undefined') ? queryParams : {};
        return Vue.http.get(this.URL + this.RESOURCE + id, { params: queryParams })
            .then(response => {
                return response.data;
            }, error => {
                return error;
            }
            );
    }

    static update(id, data = {}) {
        return Vue.http.put(this.URL + this.RESOURCE + id, data)
            .then(response => {
                return response;
            }, error => {
                return error;
            }
            );
    }

    static delete(id) {
        return Vue.http.delete(this.URL + this.RESOURCE + id)
            .then(response => {
                return response.data;
            }, error => {
                return error;
            }
            );
    }

    static storeComment(id, data = {}) {
        return Vue.http.post(this.URL + this.RESOURCE + id + this.COMMENT_RESOURCE, data)
            .then(response => {
                return response.data;
            }, error => {
                return error;
            }
            );
    }

    static listComments(id, page = 1) {
        return Vue.http.get(this.URL + this.RESOURCE + id + this.COMMENT_RESOURCE + '?page=' + page)
            .then(response => {
                return response.data;
            }, error => {
                return error;
            }
            );
    }

    static listFormTypes(page = 1) {
        return Vue.http.get(this.URL + this.TYPE_RESOURCE + '?page=' + page)
            .then(response => {
                return response.data;
            }, error => {
                return error;
            }
            );
    }

    static listFormTypeAssetCodes() {
        return Vue.http.get(this.URL + this.TYPE_RESOURCE + 'asset-codes')
            .then(response => {
                return response.data;
            }, error => {
                return error;
            }
        );
    }

    static listFormCriteria(id, page = 1) {
        return Vue.http.get(this.URL + this.RESOURCE + id + this.CRITERIA_RESOURCE + '?page=' + page)
            .then(response => {
                return response.data;
            }, error => {
                return error;
            }
            );
    }

    static listFormResponses(id, page = 1) {
        return Vue.http.get(this.URL + this.RESOURCE + id + this.RESPONSE_RESOURCE + '?page=' + page)
            .then(response => {
                return response.data;
            }, error => {
                return error;
            }
            );
    }

    static exportAsCsv(queryParams = {}) {
        // @todo - use package like Qs for better query string parameter conversions
        // https://www.npmjs.com/package/qs
        let str = Object.entries(queryParams).map(([key, val]) => `${key}=${encodeURIComponent(val)}`).join('&');
        return this.URL + '/forms-export-csv?' + str;
    }

    static listAssetCodes(id) {
        return Vue.http.get(this.URL + this.RESOURCE + id + '/asset-codes')
            .then(response => {
                return response.data;
            }, error => {
                return error;
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/services/form.service.js